import { useState, useRef, useEffect } from 'react';
import { categories, categoryImages } from '@/utils/constants';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section id="categories" className="relative w-full py-4 px-4 md:px-6 bg-background-100/50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6">
        <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap flex items-center gap-2">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-grid-line text-base text-primary-600"></i>
          </span>
          Browse Categories:
        </span>
        <div ref={dropdownRef} className="relative w-full sm:w-80">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-700 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span>{isOpen ? 'Select a category...' : 'Select a product category'}</span>
            <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
              <i className="ri-arrow-down-s-line text-sm"></i>
            </span>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-1 bg-background-50 border border-background-200/70 rounded-lg shadow-lg z-40 max-h-80 overflow-y-auto">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setIsOpen(false)}
                  className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap border-b border-background-100 last:border-b-0"
                >
                  <div className="w-9 h-9 rounded-md overflow-hidden shrink-0 bg-background-100">
                    <img
                      src={categoryImages[cat.name]}
                      alt={cat.name}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                  {cat.name}
                  <span className="w-3 h-3 flex items-center justify-center ml-auto">
                    <i className="ri-arrow-right-up-line text-xs text-foreground-400"></i>
                  </span>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}